import axios from "./../../utils/axiosInstance";
import { useEffect, useState } from "react";
import { IoIosArrowDropup } from "react-icons/io";

export const OpenAIOverview = ({ func }) => {
  const [lastChargedDate, setLastChargedDate] = useState(
    localStorage.getItem("OpenAIChargedData") || ""
  );
  const [lastChargedAmount, setLastChargedAmount] = useState(
    localStorage.getItem("OpenAIChargedAmount") || 0
  );
  const [totalCharged, setTotalCharged] = useState(
    localStorage.getItem("OpenAITotalCharged") || 0
  );
  const { setDropDownNo } = func;
  const handleDateChange = (e) => {
    const newDate = e.target.value;
    setLastChargedDate(newDate);
    localStorage.setItem("OpenAIChargedData", newDate);
  };

  const handleAmountChange = (e) => {
    const newAmount = parseFloat(e.target.value); // Ensure it's a number
    if (!isNaN(newAmount) && newAmount >= 0) {
      // Basic validation
      setLastChargedAmount(newAmount.toString());
      setTotalCharged((parseFloat(totalCharged) + newAmount).toString());
      localStorage.setItem("OpenAIChargedAmount", newAmount.toString());
      localStorage.setItem(
        "OpenAITotalCharged",
        (parseFloat(totalCharged) + newAmount).toString()
      );
    }
  };
  return (
    <div className="flex flex-col gap-3 mt-5 border-t pt-2">
      <div className="flex flex-row items-center justify-between">
        <p className="text-xs">In details</p>
        <button onClick={() => setDropDownNo(0)}>
          <IoIosArrowDropup />
        </button>
      </div>
      <div className="flex flex-row items-center justify-between w-auto pt-2">
        <p className="text-xs">Date of last charge: </p>
        <input
          className="w-8 text-sm text-right"
          placeholder="..."
          value={lastChargedDate}
          onChange={(e) => {
            handleDateChange(e);
          }}
        />
      </div>
      <div className="flex flex-row items-center justify-between w-auto">
        <p className="text-xs">Amount($) of last charge: </p>
        <input
          className="w-8 text-sm text-right"
          placeholder="..."
          value={lastChargedAmount}
          onChange={(e) => {
            handleAmountChange(e);
          }}
        />
      </div>
      <div className="flex flex-row items-center justify-between w-auto">
        <p className="text-xs">Total: </p>
        <p className="text-sm">{totalCharged}</p>
      </div>
    </div>
  );
};

export const AnthropicOverview = ({ func }) => {
  const [lastChargedDate, setLastChargedDate] = useState(
    localStorage.getItem("AnthropicChargedData") || ""
  );
  const [lastChargedAmount, setLastChargedAmount] = useState(
    localStorage.getItem("AnthropicChargedAmount") || 0
  );
  const [totalCharged, setTotalCharged] = useState(
    localStorage.getItem("AnthropicTotalCharged") || 0
  );
  const { setDropDownNo } = func;
  const handleDateChange = (e) => {
    const newDate = e.target.value;
    setLastChargedDate(newDate);
    localStorage.setItem("AnthropicChargedData", newDate);
  };

  const handleAmountChange = (e) => {
    const newAmount = parseFloat(e.target.value); // Ensure it's a number
    if (!isNaN(newAmount) && newAmount >= 0) {
      // Basic validation
      setLastChargedAmount(newAmount.toString());
      setTotalCharged((parseFloat(totalCharged) + newAmount).toString());
      localStorage.setItem("AnthropicChargedAmount", newAmount.toString());
      localStorage.setItem(
        "AnthropicTotalCharged",
        (parseFloat(totalCharged) + newAmount).toString()
      );
    }
  };
  return (
    <div className="flex flex-col gap-3 mt-5 border-t pt-2">
      <div className="flex flex-row items-center justify-between">
        <p className="text-xs">In details</p>
        <button onClick={() => setDropDownNo(0)}>
          <IoIosArrowDropup />
        </button>
      </div>
      <div className="flex flex-row items-center justify-between w-auto pt-2">
        <p className="text-xs">Date of last charge: </p>
        <input
          className="w-8 text-sm text-right"
          placeholder="..."
          value={lastChargedDate}
          onChange={(e) => {
            handleDateChange(e);
          }}
        />
      </div>
      <div className="flex flex-row items-center justify-between w-auto">
        <p className="text-xs">Amount($) of last charge: </p>
        <input
          className="w-8 text-sm text-right"
          placeholder="..."
          value={lastChargedAmount}
          onChange={(e) => {
            handleAmountChange(e);
          }}
        />
      </div>
      <div className="flex flex-row items-center justify-between w-auto">
        <p className="text-xs">Total: </p>
        <p className="text-sm">{totalCharged}</p>
      </div>
    </div>
  );
};
export const DeepseekOverview = ({ func }) => {
  const [lastChargedDate, setLastChargedDate] = useState(
    localStorage.getItem("DeepseekChargedData") || ""
  );
  const [lastChargedAmount, setLastChargedAmount] = useState(
    localStorage.getItem("DeepseekChargedAmount") || 0
  );
  const [totalCharged, setTotalCharged] = useState(
    localStorage.getItem("DeepseekTotalCharged") || 0
  );
  const { setDropDownNo } = func;
  const handleDateChange = (e) => {
    const newDate = e.target.value;
    setLastChargedDate(newDate);
    localStorage.setItem("DeepseekChargedData", newDate);
  };

  const handleAmountChange = (e) => {
    const newAmount = parseFloat(e.target.value); // Ensure it's a number
    if (!isNaN(newAmount) && newAmount >= 0) {
      // Basic validation
      setLastChargedAmount(newAmount.toString());
      setTotalCharged((parseFloat(totalCharged) + newAmount).toString());
      localStorage.setItem("DeepseekChargedAmount", newAmount.toString());
      localStorage.setItem(
        "DeepseekTotalCharged",
        (parseFloat(totalCharged) + newAmount).toString()
      );
    }
  };
  return (
    <div className="flex flex-col gap-3 mt-5 border-t pt-2">
      <div className="flex flex-row items-center justify-between">
        <p className="text-xs">In details</p>
        <button onClick={() => setDropDownNo(0)}>
          <IoIosArrowDropup />
        </button>
      </div>
      <div className="flex flex-row items-center justify-between w-auto pt-2">
        <p className="text-xs">Date of last charge: </p>
        <input
          className="w-8 text-sm text-right"
          placeholder="..."
          value={lastChargedDate}
          onChange={(e) => {
            handleDateChange(e);
          }}
        />
      </div>
      <div className="flex flex-row items-center justify-between w-auto">
        <p className="text-xs">Amount($) of last charge: </p>
        <input
          className="w-8 text-sm text-right"
          placeholder="..."
          value={lastChargedAmount}
          onChange={(e) => {
            handleAmountChange(e);
          }}
        />
      </div>
      <div className="flex flex-row items-center justify-between w-auto">
        <p className="text-xs">Total: </p>
        <p className="text-sm">{totalCharged}</p>
      </div>
    </div>
  );
};

export const ApifyOverview = ({ func }) => {
  const [startAt, setStartAt] = useState("");
  const [endAt, setEndAt] = useState("");
  const [lastChargedAmount, setLastChargedAmount] = useState(
    localStorage.getItem("ApifyChargedAmount") || 0
  );
  const [totalCharged, setTotalCharged] = useState(
    localStorage.getItem("ApifyTotalCharged") || 0
  );
  const { setDropDownNo } = func;

  const handleAmountChange = (e) => {
    const newAmount = parseFloat(e.target.value); // Ensure it's a number
    if (!isNaN(newAmount) && newAmount >= 0) {
      // Basic validation
      setLastChargedAmount(newAmount.toString());
      setTotalCharged((parseFloat(totalCharged) + newAmount).toString());
      localStorage.setItem("ApifyChargedAmount", newAmount.toString());
      localStorage.setItem(
        "ApifyTotalCharged",
        (parseFloat(totalCharged) + newAmount).toString()
      );
    }
  };
  useEffect(() => {
    const getData = async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_BASED_URL}/usageCheck/apify`
      );
      setStartAt(response.data?.startAt);
      setEndAt(response.data?.endAt);
    };
    getData();
  }, []);

  return (
    <div className="flex flex-col gap-3 mt-5 border-t pt-2">
      <div className="flex flex-row items-center justify-between">
        <p className="text-xs">In details</p>
        <button onClick={() => setDropDownNo(0)}>
          <IoIosArrowDropup />
        </button>
      </div>
      <div className="flex flex-row items-center justify-between w-auto pt-2">
        <p className="text-xs">Start At: </p>
        <p className="text-sm">{startAt}</p>
      </div>
      <div className="flex flex-row items-center justify-between w-auto">
        <p className="text-xs">End At: </p>
        <p className="text-sm">{endAt}</p>
      </div>
      <div className="flex flex-row items-center justify-between w-auto">
        <p className="text-xs">Amount($) of last charge: </p>
        <input
          className="w-8 text-sm text-right"
          placeholder="..."
          value={lastChargedAmount}
          onChange={(e) => {
            handleAmountChange(e);
          }}
        />
      </div>
      <div className="flex flex-row items-center justify-between w-auto">
        <p className="text-xs">Total: </p>
        <p className="text-sm">{totalCharged}</p>
      </div>
    </div>
  );
};

export const AWSOverview = ({ func }) => {
  const [lastChargedDate, setLastChargedDate] = useState(
    localStorage.getItem("AWSChargedData") || ""
  );
  const [lastChargedAmount, setLastChargedAmount] = useState(
    localStorage.getItem("AWSChargedAmount") || 0
  );
  const [totalCharged, setTotalCharged] = useState(
    localStorage.getItem("AWSTotalCharged") || 0
  );
  const { setDropDownNo } = func;
  const handleDateChange = (e) => {
    const newDate = e.target.value;
    setLastChargedDate(newDate);
    localStorage.setItem("AWSChargedData", newDate);
  };

  const handleAmountChange = (e) => {
    const newAmount = parseFloat(e.target.value); // Ensure it's a number
    if (!isNaN(newAmount) && newAmount >= 0) {
      // Basic validation
      setLastChargedAmount(newAmount.toString());
      setTotalCharged((parseFloat(totalCharged) + newAmount).toString());
      localStorage.setItem("AWSChargedAmount", newAmount.toString());
      localStorage.setItem(
        "AWSTotalCharged",
        (parseFloat(totalCharged) + newAmount).toString()
      );
    }
  };
  return (
    <div className="flex flex-col gap-3 mt-5 border-t pt-2">
      <div className="flex flex-row items-center justify-between">
        <p className="text-xs">In details</p>
        <button onClick={() => setDropDownNo(0)}>
          <IoIosArrowDropup />
        </button>
      </div>
      <div className="flex flex-row items-center justify-between w-auto pt-2">
        <p className="text-xs">Date of last charge: </p>
        <input
          className="w-8 text-sm text-right"
          placeholder="..."
          value={lastChargedDate}
          onChange={(e) => {
            handleDateChange(e);
          }}
        />
      </div>
      <div className="flex flex-row items-center justify-between w-auto">
        <p className="text-xs">Amount($) of last charge: </p>
        <input
          className="w-8 text-sm text-right"
          placeholder="..."
          value={lastChargedAmount}
          onChange={(e) => {
            handleAmountChange(e);
          }}
        />
      </div>
      <div className="flex flex-row items-center justify-between w-auto">
        <p className="text-xs">Total: </p>
        <p className="text-sm">{totalCharged}</p>
      </div>
    </div>
  );
};
